import { FC, useEffect, useRef } from "react";

import { usePagingStickyEmulation } from "@ryde/controls";
import { useLayoutMainContext } from "@ryde/redux";

import { HeaderBottom } from "./bottom-line";
import { IHeaderProps } from "./page-header.models";
import { PageHeaderFirstLine, PageHeaderStyled } from "./page-header.styled";
import {
  HeaderSupplierPriceIndicator,
  HeaderTopGlobalSearch,
  HeaderTopRight,
  HeaderTopTitle,
} from "./top-line";

export const PageHeaderDesktop: FC<IHeaderProps> = ({
  mainTitle,
  customRightComponent,
  topWidgetComponent,
  bottomWidgetComponent,
  customHeaderBottomLeftComponent,
  customHeaderBottomRightActions,
  hideSecondLine,
  hideGlobalSearch,
  children,
}) => {
  const desktopHeaderRef = useRef<HTMLDivElement>(null);
  usePagingStickyEmulation({ pagingRef: desktopHeaderRef });
  const { setHeaderElement, headerElement } = useLayoutMainContext();

  useEffect(() => {
    if (headerElement) {
      return;
    }

    setHeaderElement(desktopHeaderRef.current);
  }, [headerElement, setHeaderElement]);
  useEffect(() => {
    return () => {
      setHeaderElement(null);
    };
  }, [setHeaderElement]);

  return (
    <PageHeaderStyled ref={desktopHeaderRef}>
      <PageHeaderFirstLine>
        <HeaderTopTitle mainTitle={mainTitle} />
        {topWidgetComponent}
        {!hideGlobalSearch && <HeaderTopGlobalSearch />}
        <HeaderSupplierPriceIndicator />
        <HeaderTopRight />
      </PageHeaderFirstLine>
      {!hideSecondLine && (
        <HeaderBottom
          customRightComponent={customRightComponent}
          customHeaderBottomLeftComponent={customHeaderBottomLeftComponent}
          rightActions={customHeaderBottomRightActions}
        >
          {children}
        </HeaderBottom>
      )}
      {Boolean(bottomWidgetComponent) && bottomWidgetComponent}
    </PageHeaderStyled>
  );
};
